import gql from "graphql-tag";

export default {
  getAuthorRoles: gql`
    query getAuthorRoles {
      authorRoles {
        id
        _id
        description
      }
    }
  `
};
